import type {
  ReactElement,
} from 'react';

import { Radio } from '../Radio';
import type {
  RadioValue,
} from '../Radio';

import {
  StyledRadioGroup,
  StyledItemWrapper,
} from './styled';

export type RadioGroupProps = {
  /**
    * инлайновый вывод
    */
  inline?: boolean;

  /**
   * name каждого html-элемента input
   */
  name?: string;
  /**
   * значение выбранной опции
   */
  value?: RadioValue | null;
  /**
   * выключена ли данная группа радио
   */
  disabled?: boolean;
  /**
   * список опций данной группы радио
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: Record<string, any>[];

  /**
   * ключ, по которому хранятся значения в объектах options
   */
  valueKey?: string;
  /**
   * ключ, по которому хранятся заголовки в объектах options
   */
  labelKey?: string;

  /**
   * хэндлер изменения значения
   */
  onChange?: (value: RadioValue) => void;
};

export function RadioGroup({
  inline = false,

  name = '',
  value = null,
  disabled = false,
  options,
  valueKey = 'value',
  labelKey = 'label',

  onChange = undefined,
}: RadioGroupProps): ReactElement {
  return (
    <StyledRadioGroup $isInline={inline}>
      {
        options.map((option) => {
          const optionValue = option[valueKey] as string;

          return (
            <StyledItemWrapper
              $isInline={inline}
              key={optionValue}
            >
              <Radio
                value={optionValue}
                checked={optionValue === value}
                disabled={disabled}
                name={name}
                label={option[labelKey] as string}
                onChange={onChange}
              />
            </StyledItemWrapper>
          );
        })
      }
    </StyledRadioGroup>
  );
}
